/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { formFromBackupInitialValues } from '../../../../../../containers/CreateClusterOverlay/CreateClusterOverlay.consts';
import { ChangePlanFormValues } from './ChangePlanForm.types';

export const formInitialValues: ChangePlanFormValues = {
  ...formFromBackupInitialValues,
  suggestedPgConfigParameters: {},
};
